import { type PropsWithChildren, type ReactElement, useCallback, useMemo } from 'react';
import { ThemeModeContext } from './ThemeModeContext';
import type { PaletteMode } from '@/ui/primitives';

const forcedThemeMode: PaletteMode = 'dark';

export const ThemeModeProvider = ({ children }: PropsWithChildren): ReactElement => {
  const setMode = useCallback((_nextMode: PaletteMode) => undefined, []);
  const toggleMode = useCallback(() => undefined, []);
  const value = useMemo(
    () => ({ mode: forcedThemeMode, setMode, toggleMode }),
    [setMode, toggleMode],
  );

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};
